<template>
    <div class="row cartItem">
        <div class="col-2 d-none d-sm-block" >
            <img v-if="item.product" :src="item.product.thumbnail_url" alt="" class="image">
        </div>

        <div class="col-10 col-sm-8 col-md-8 col-lg-9">
            <div class="row ">
                <div class="col-12">
                    <div class="row ">
                        <div class="col-12">
                            <div class="title">
                                {{ item.product.name }}
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div v-if="!isWithoutDateSellingMode" class="row ">
                                <div class="col-12">
                                    <div class="date info">
                                        <div class="label">Data:</div>

                                        <div class="content">
                                            {{ formatedDate }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col-12">
                                    <div class="tariff info">
                                        <div class="label">Tarifas:</div>

                                        <div class="content">
                                            {{item.tariffs.map(tariff=>`${ tariff.tariff.type.name } - ${tariff.amount}`).join(', ')}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col-12">
                                    <div class="value info">
                                        <div class="label">Lugar selecionado:</div>

                                        <div class="content">
                                            {{ selectedResources.join(', ') }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col-12">
                                    <div class="value info">
                                        <div class="label">Valor:</div>

                                        <div class="content">
                                            {{ formatValueCents(item.totalSummaryValue) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-2 col-sm-2 col-md-2 col-lg-1">
            <button type="button" class="removeButton" @click.stop="onRemove()">
                <i class="material-icons" >delete</i>
            </button>
        </div>
    </div>
</template>

<script>

import moment from 'moment';

export default {
    components: {  },
    props: {
        item: {
            type: Object,
            required: true,
        },
        onRemove: {
            type: Function,
            required: true,
        }
    },
    data(){
        return {
        };
    },
    computed: {
        selectedResources() {
            return this.item.resources.map(resource => resource.name);
        },
        formatedDate() {
            return moment(this.item.date.date).format('DD/MM/yyyy');
        },
        isDateTimeSellingMode() {
            return this.item.product.selling_mode === 'with_date_and_time';
        },
        isDateSellingMode() {
            return this.item.product.selling_mode === 'with_date_only';
        },
        isWithoutDateSellingMode() {
            return this.item.product.selling_mode === 'without_date';
        },
    },
    methods: {
        formatValueCents(value) {
            return (value/100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.cartItem {
    display: flex;
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }

    .image {
        width: 100%;
    }

    .info {
        font-size: 12px;
        display: flex;
        margin-bottom: 5px;

        &:last-child {
            margin-bottom: 0;
        }

        .label {
            font-weight: bold;
            margin-right: 5px;
        }

        .content {

        }
    }

    .removeButton {
        vertical-align: middle;
        display: flex;
        align-items: center;
        height: 100%;
        border: 0;
        background: none;

        &:hover {
            text-decoration: none;
        }
    }
}
</style>
